import * as product from '../constants/product-types'

export const cardFlags = {
    [product.CHRISTMAS]: 'EC_EXIBE_NATAL',
    [product.CULTURE]: 'EC_EXIBE_CULTURA',
    [product.FEED]: 'EC_EXIBE_ALIMENTACAO',
    [product.MEAL]: 'EC_EXIBE_REFEICAO',
    [product.TUDO]: 'EC_EXIBE_ALELO_TUDO',
    [product.POD]: 'EC_EXIBE_ALELO_POD',
    [product.EXPENSES]: 'EC_EXIBE_DESPESAS',
    [product.PAYMENTS]: 'EC_EXIBE_PAGAMENTOS',
    [product.VT]: 'EC_EXIBE_VT',
    [product.AWARDS]: 'EC_EXIBE_PREMIACAO',
    [product.FLEET]: 'EC_EXIBE_GO_COMB',
    [product.VELOE]: 'EC_EXIBE_VELOE_PEDAGIO'
}
